import { Link } from 'react-router-dom';
import { getFeaturedArticles } from '@/mocks/articles';

const features = [
  {
    icon: 'ri-fire-line',
    title: 'Discover Trending Products',
    description: 'Stay ahead of the curve with regularly updated Sugargoo Spreadsheet collections featuring the hottest products that real shoppers are buying right now.',
    image: 'https://readdy.ai/api/search-image?query=Trending%20product%20discovery%20concept%20with%20warm%20cream%20and%20beige%20tones%2C%20elegant%20curated%20item%20arrangement%2C%20soft%20natural%20lighting%2C%20sophisticated%20minimalist%20retail%20aesthetic%2C%20calm%20organized%20atmosphere%2C%20editorial%20style%2C%20subtle%20terracotta%20accent%20details%2C%20no%20people&width=600&height=400&seq=feature-img-trending-v2&orientation=landscape',
  },
  {
    icon: 'ri-scales-3-line',
    title: 'Compare Product Options',
    description: 'Make informed decisions with side-by-side comparisons of similar products, including pricing, quality grades, sizing information, and community ratings.',
    image: 'https://readdy.ai/api/search-image?query=Product%20comparison%20concept%20with%20warm%20beige%20palette%2C%20two%20similar%20items%20side%20by%20side%20on%20clean%20cream%20surface%2C%20soft%20natural%20shadows%2C%20minimalist%20comparison%20aesthetic%2C%20calm%20analytical%20atmosphere%2C%20editorial%20product%20review%20style%2C%20warm%20sand%20tones%2C%20no%20people&width=600&height=400&seq=feature-img-compare-v2&orientation=landscape',
  },
  {
    icon: 'ri-time-line',
    title: 'Save Research Time',
    description: 'Skip hours of manual browsing. The Sugargoo Spreadsheet aggregates thousands of verified finds into organized, searchable categories for instant access.',
    image: 'https://readdy.ai/api/search-image?query=Efficient%20organized%20workspace%20concept%20with%20warm%20cream%20tones%2C%20clean%20desk%20with%20subtle%20productivity%20elements%2C%20soft%20natural%20lighting%2C%20minimalist%20time%20saving%20visual%2C%20calm%20focused%20atmosphere%2C%20editorial%20workflow%20aesthetic%2C%20warm%20beige%20and%20sand%20palette%2C%20no%20people&width=600&height=400&seq=feature-img-savetime-v2&orientation=landscape',
  },
  {
    icon: 'ri-money-dollar-circle-line',
    title: 'Find Better Deals',
    description: 'Access exclusive discount codes, track price drops, and discover budget-friendly alternatives through community-curated Sugargoo Spreadsheet recommendations.',
    image: 'https://readdy.ai/api/search-image?query=Savings%20and%20value%20concept%20with%20warm%20beige%20and%20cream%20palette%2C%20elegant%20price%20tag%20elements%2C%20soft%20natural%20lighting%2C%20minimalist%20bargain%20hunting%20aesthetic%2C%20calm%20inviting%20atmosphere%2C%20editorial%20retail%20savings%20style%2C%20warm%20terracotta%20and%20sand%20tones%2C%20no%20people&width=600&height=400&seq=feature-img-deals-v2&orientation=landscape',
  },
  {
    icon: 'ri-camera-lens-line',
    title: 'Review QC Photo References',
    description: 'Before purchasing, browse real quality control photos and buyer feedback to understand exactly what you will receive versus what listings show.',
    image: 'https://readdy.ai/api/search-image?query=Quality%20inspection%20concept%20with%20warm%20cream%20tones%2C%20magnifying%20detail%20view%20aesthetic%2C%20soft%20natural%20lighting%2C%20minimalist%20product%20verification%20visual%2C%20calm%20analytical%20atmosphere%2C%20editorial%20quality%20check%20style%2C%20warm%20beige%20and%20sand%20palette%2C%20no%20people&width=600&height=400&seq=feature-img-qc-v2&orientation=landscape',
  },
  {
    icon: 'ri-group-line',
    title: 'Join the Shopper Community',
    description: 'Connect with experienced Sugargoo Spreadsheet users who share finds, tips, and honest reviews that help everyone shop smarter together.',
    image: 'https://readdy.ai/api/search-image?query=Community%20connection%20concept%20with%20warm%20beige%20and%20cream%20palette%2C%20abstract%20interconnected%20elements%2C%20soft%20natural%20lighting%2C%20minimalist%20social%20network%20visual%2C%20calm%20welcoming%20atmosphere%2C%20editorial%20collaboration%20aesthetic%2C%20warm%20terracotta%20and%20sand%20tones%2C%20no%20people&width=600&height=400&seq=feature-img-community-v2&orientation=landscape',
  },
];

const featuredArticles = getFeaturedArticles();

export default function ContentSections() {
  return (
    <>
      <section id="what-is" className="py-16 md:py-20 bg-background-100">
        <div className="max-w-5xl mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-4">
              What Is the Sugargoo Spreadsheet?
            </h2>
            <p className="text-foreground-600 max-w-3xl mx-auto text-sm md:text-base leading-relaxed">
              The Sugargoo Spreadsheet is a curated resource that helps shoppers discover popular products, compare options, review quality information, and make smarter purchasing decisions through organized product collections. It bridges the gap between Chinese marketplaces and international buyers, making product discovery faster and more efficient than traditional search methods.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {features.map((feature) => (
              <div key={feature.title} className="bg-background-50 rounded-xl overflow-hidden transition-all duration-300 hover:ring-2 hover:ring-accent-200">
                <div className="aspect-[3/2] w-full overflow-hidden">
                  <img
                    src={feature.image}
                    alt={feature.title}
                    className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-5">
                  <div className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center mb-3">
                    <i className={`${feature.icon} text-lg text-accent-600`}></i>
                  </div>
                  <h3 className="font-semibold text-foreground-950 mb-2 text-sm">{feature.title}</h3>
                  <p className="text-xs text-foreground-600 leading-relaxed">{feature.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 md:py-20 bg-background-50">
        <div className="max-w-5xl mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-4">
              Sugargoo Spreadsheet vs Traditional Search
            </h2>
            <p className="text-foreground-600 max-w-2xl mx-auto text-sm">
              See why thousands of smart shoppers prefer the organized power of the Sugargoo Spreadsheet over scattered traditional browsing.
            </p>
          </div>

          <div className="overflow-x-auto">
            <table className="w-full border-collapse bg-background-100 rounded-xl overflow-hidden">
              <thead>
                <tr className="border-b border-background-200">
                  <th className="text-left py-4 px-6 font-semibold text-foreground-950 text-sm">Feature</th>
                  <th className="text-left py-4 px-6 font-semibold text-primary-600 text-sm">
                    <div className="flex items-center gap-2">
                      <div className="w-5 h-5 flex items-center justify-center">
                        <i className="ri-file-list-3-line"></i>
                      </div>
                      Sugargoo Spreadsheet
                    </div>
                  </th>
                  <th className="text-left py-4 px-6 font-semibold text-foreground-600 text-sm">
                    <div className="flex items-center gap-2">
                      <div className="w-5 h-5 flex items-center justify-center">
                        <i className="ri-search-line"></i>
                      </div>
                      Traditional Search
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-background-200">
                {[
                  { feature: 'Product Discovery Speed', ss: 'Fast — organized by category', ts: 'Slow — manual scrolling required' },
                  { feature: 'Data Organization', ss: 'Structured database', ts: 'Scattered across platforms' },
                  { feature: 'Research Time', ss: 'Minutes per product', ts: 'Hours of digging' },
                  { feature: 'Quality Verification', ss: 'Community-reviewed QC photos', ts: 'Unreliable listing photos' },
                  { feature: 'Price Comparison', ss: 'Side-by-side in one view', ts: 'Manual tab switching' },
                  { feature: 'Trend Discovery', ss: 'Crowdsourced trending picks', ts: 'Algorithm-driven suggestions' },
                ].map((row) => (
                  <tr key={row.feature} className="hover:bg-background-50 transition-colors">
                    <td className="py-4 px-6 text-sm text-foreground-800 font-medium">{row.feature}</td>
                    <td className="py-4 px-6 text-sm text-accent-700">{row.ss}</td>
                    <td className="py-4 px-6 text-sm text-foreground-500">{row.ts}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>

      <section id="reviews" className="py-16 md:py-20 bg-background-100">
        <div className="max-w-5xl mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-4">
              Is Sugargoo Legit? Honest Review
            </h2>
            <p className="text-foreground-600 max-w-2xl mx-auto text-sm">
              Sugargoo is a legitimate Chinese shopping agent platform that helps international buyers purchase products from Chinese marketplaces. Here is what you need to know.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="bg-background-50 rounded-xl p-6">
              <h3 className="font-semibold text-accent-700 flex items-center gap-2 mb-4">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-check-line"></i>
                </div>
                Pros
              </h3>
              <ul className="space-y-3">
                {[
                  'Established platform with years of operation',
                  'Comprehensive warehouse and QC inspection services',
                  'Competitive shipping rates with multiple carrier options',
                  'Active community with extensive product knowledge',
                  'Regular promotions and discount opportunities',
                  'Reliable order processing and tracking system',
                ].map((pro) => (
                  <li key={pro} className="flex items-start gap-3 text-sm text-foreground-700">
                    <div className="w-5 h-5 flex items-center justify-center mt-0.5 shrink-0">
                      <i className="ri-checkbox-circle-fill text-accent-500 text-sm"></i>
                    </div>
                    {pro}
                  </li>
                ))}
              </ul>
            </div>

            <div className="bg-background-50 rounded-xl p-6">
              <h3 className="font-semibold text-primary-600 flex items-center gap-2 mb-4">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-information-line"></i>
                </div>
                Things to Know
              </h3>
              <ul className="space-y-3">
                {[
                  'Shipping costs vary significantly by method and destination',
                  'Processing times depend on seller responsiveness',
                  'Quality can vary — always review QC photos carefully',
                  'Language barriers may require translation tools',
                  'Return policies differ from domestic e-commerce',
                  'Currency conversion and payment fees may apply',
                ].map((con) => (
                  <li key={con} className="flex items-start gap-3 text-sm text-foreground-700">
                    <div className="w-5 h-5 flex items-center justify-center mt-0.5 shrink-0">
                      <i className="ri-information-line text-primary-500 text-sm"></i>
                    </div>
                    {con}
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="text-center mt-10">
            <Link
              to="/article/is-sugargoo-legit-complete-review"
              className="inline-flex items-center gap-2 px-8 py-3 rounded-lg bg-secondary-500 text-background-50 font-semibold text-sm hover:bg-secondary-600 transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              Read the Complete Sugargoo Review
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line"></i>
              </div>
            </Link>
          </div>
        </div>
      </section>

      <section id="shipping" className="py-16 md:py-20 bg-background-50">
        <div className="max-w-5xl mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-4">
              Sugargoo Shipping Cost Guide
            </h2>
            <p className="text-foreground-600 max-w-2xl mx-auto text-sm">
              Compare shipping methods, delivery times, and estimated costs to choose the best option for your Sugargoo orders.
            </p>
          </div>

          <div className="overflow-x-auto">
            <table className="w-full border-collapse bg-background-100 rounded-xl overflow-hidden">
              <thead>
                <tr className="border-b border-background-200">
                  <th className="text-left py-4 px-6 font-semibold text-foreground-950 text-sm">Shipping Method</th>
                  <th className="text-left py-4 px-6 font-semibold text-foreground-950 text-sm">Delivery Time</th>
                  <th className="text-left py-4 px-6 font-semibold text-foreground-950 text-sm">Cost Range</th>
                  <th className="text-left py-4 px-6 font-semibold text-foreground-950 text-sm">Best For</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-background-200">
                {[
                  { method: 'EMS', time: '7-15 days', cost: '$$', best: 'Balanced speed and cost' },
                  { method: 'E-EMS', time: '7-20 days', cost: '$', best: 'Budget-friendly shipping' },
                  { method: 'DHL', time: '3-7 days', cost: '$$$', best: 'Fastest delivery option' },
                  { method: 'UPS', time: '4-8 days', cost: '$$$', best: 'Reliable express shipping' },
                  { method: 'FedEx', time: '4-8 days', cost: '$$$', best: 'Priority international shipping' },
                  { method: 'SAL', time: '15-30 days', cost: '$', best: 'Low-cost non-urgent orders' },
                  { method: 'Sea Mail', time: '30-60 days', cost: '$', best: 'Large heavy shipments' },
                ].map((row) => (
                  <tr key={row.method} className="hover:bg-background-50 transition-colors">
                    <td className="py-4 px-6 text-sm font-medium text-foreground-900">{row.method}</td>
                    <td className="py-4 px-6 text-sm text-foreground-700">{row.time}</td>
                    <td className="py-4 px-6 text-sm text-primary-600 font-medium">{row.cost}</td>
                    <td className="py-4 px-6 text-sm text-foreground-600">{row.best}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="text-center mt-8">
            <Link
              to="/article/sugargoo-shipping-cost-guide"
              className="inline-flex items-center gap-2 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors cursor-pointer"
            >
              Read Full Shipping Cost Guide
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line"></i>
              </div>
            </Link>
          </div>
        </div>
      </section>

      <section className="py-16 md:py-20 bg-background-100">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-12">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-4">
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-article-line"></i>
              </div>
              SEO Articles
            </div>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-4">
              Sugargoo Spreadsheet Guides & Resources
            </h2>
            <p className="text-foreground-600 max-w-2xl mx-auto text-sm md:text-base">
              Explore our comprehensive collection of Sugargoo guides, reviews, comparisons, and shopping tips — written to help you shop smarter and save more.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {featuredArticles.map((article) => (
              <Link
                key={article.slug}
                to={`/article/${article.slug}`}
                className="group bg-background-50 rounded-xl overflow-hidden transition-all duration-300 hover:ring-2 hover:ring-primary-200 cursor-pointer flex flex-col"
              >
                <div className="aspect-[16/9] w-full overflow-hidden">
                  <img
                    src={article.featuredImage}
                    alt={article.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-5 flex flex-col flex-1">
                  <div className="flex items-center gap-2 mb-3">
                    <span className="px-2.5 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium">
                      {article.category}
                    </span>
                    <span className="text-xs text-foreground-400">{article.readTime}</span>
                  </div>
                  <h3 className="font-heading text-base font-bold text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors duration-300 line-clamp-2">
                    {article.title}
                  </h3>
                  <p className="text-xs text-foreground-600 leading-relaxed mb-4 flex-1 line-clamp-2">
                    {article.excerpt}
                  </p>
                  <div className="flex items-center gap-2 text-xs font-medium text-primary-500">
                    Read Article
                    <div className="w-3.5 h-3.5 flex items-center justify-center">
                      <i className="ri-arrow-right-line"></i>
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </div>

          <div className="text-center mt-10">
            <Link
              to="/article/sugargoo-spreadsheet-beginner-tutorial"
              className="inline-flex items-center gap-2 px-8 py-3 rounded-lg bg-secondary-500 text-background-50 font-semibold text-sm hover:bg-secondary-600 transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              View All Guides
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line"></i>
              </div>
            </Link>
          </div>
        </div>
      </section>

      <section className="py-16 md:py-20 bg-primary-500">
        <div className="max-w-5xl mx-auto px-6 text-center">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-background-50 mb-4">
            Ready to Start Shopping?
          </h2>
          <p className="text-background-50/85 max-w-2xl mx-auto text-sm md:text-base mb-8">
            Explore thousands of curated products through the Sugargoo Spreadsheet and discover your next favorite find today.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-10 py-4 rounded-lg bg-background-50 text-primary-600 font-bold text-sm hover:bg-background-100 transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              Visit Sugargoo Spreadsheet
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-up-line"></i>
              </div>
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-10 py-4 rounded-lg border-2 border-background-50/40 text-background-50 font-bold text-sm hover:bg-background-50/10 transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              Buy It Now
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-shopping-bag-line"></i>
              </div>
            </a>
          </div>
        </div>
      </section>
    </>
  );
}